import { render, staticRenderFns } from "./TopicCU.vue?vue&type=template&id=0ba985fe"
import script from "./TopicCU.vue?vue&type=script&lang=js"
export * from "./TopicCU.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports